import { useCallback } from 'react'
import { useSetSidepanelState } from '../atoms'
import { useViewActions, type OpenViewFunction } from '../Sidepanel/view-atoms'
import type { ViewId } from '../Sidepanel/view-definitions'

export function useOpenViewInSidepanel() {
  const setSidepanelState = useSetSidepanelState()
  const { openView } = useViewActions()

  const openViewInSidepanel = useCallback<OpenViewFunction>(
    (...args) => {
      // The view router animates a replacement itself, so opening over an
      // existing view no longer needs the close-then-reopen dance — nor the
      // frame of deferral that dance required, which only left a window for a
      // user's back to land between the open and the push.
      const [id, context, options] = args
      setSidepanelState('open')
      // The one cast: TS won't feed a conditional-tuple rest back into the
      // generic signature it was declared from. That signature is
      // `OpenViewFunction` above — shared with `openView` rather than restated
      // — so every call site is still checked against the same contract.
      ;(openView as (id: ViewId, context?: unknown, options?: unknown) => void)(id, context, options)
    },
    [setSidepanelState, openView],
  )

  return { openViewInSidepanel }
}
